import { useEffect } from "react"

import { outfitterAssistantPathnameVar } from "~utils/outfitter-assistant-pathname-var"

interface Props {
    readonly pathname: string
}

export default function SyncOutfitterAssistantPathname({ pathname }: Props) {
    useEffect(() => {
        outfitterAssistantPathnameVar(pathname)
    }, [pathname])

    return null
}
